import React, { useEffect, useState } from 'react';
import * as Store from '@apply/store';
import { lookupAddress, getDemographicsTable } from './demographicsApi';

export interface DemographicsReviewProps {
    address: Store.CrossStore.IAddress;
}

export const DemographicsReview: React.FC<DemographicsReviewProps> = ({ address }) => {
    const [table, set_table] = useState('');

    useEffect(() => {
        async function initialize(address) {
            const results = await lookupAddress(address);
            if (results) {
                switch (results.length) {
                    case 0:
                        set_table('Demographics search did not recognize the address');
                        break;
                    case 1: {
                        const addr = results[0].toJSON();
                        const location = {
                            latitude: addr.location.y,
                            longitude: addr.location.x,
                        };
                        const demographicTable = await getDemographicsTable(location);
                        set_table(demographicTable);
                        break;
                    }
                    default:
                        set_table('Demographics found multiple matching addresses');
                        break;
                }
            } else {
                set_table('Demographics search did not recognize the address');
            }
        }
        initialize(address);
    }, [address]);

    return (
        <>
            {table && (
                <div style={{ paddingBottom: '15px' }}>
                    <h4>Demographics</h4>
                    <div
                        style={{ padding: '0px 17px', width: '100%' }}
                        dangerouslySetInnerHTML={{ __html: table }}
                    ></div>
                </div>
            )}
        </>
    );
};
